import axios from 'axios';

const client = axios.create();

client.interceptors.request.use(async (config) => {
    const token = await shopify.idToken();
    config.headers.Authorization = `Bearer ${token}`;

    return config;
})

const Api = {
    upsertCustomer: async (params) => {
        if ( params.id ) {
            return client.put('/ajax/customers/' + params.id, params);
        }

        return client.post('/ajax/customers', params);
    },

    listUnapprovedCustomers: async (page = 1) => {
        return client.get('/ajax/customers/unapproved', {
            params: { page },
        });
    },

    findCustomer: async (query) => {
        return client.get('/ajax/customers/find', {
            params: {q: query},
        });
    },

    getCustomer: async (id) => {
        return client.get(`/ajax/customers/${id}`);
    },


    getLocations: async (customerId, page = 1, search = '') => {
        return client.get(`/ajax/customers/${customerId}/locations?page=${page}&q=${search}`);
    },

    getLocation: async (locationId) => {
        return client.get(`/ajax/locations/${locationId}`);
    },

    updateLocation: async(locationId, payload) => {
        return client.put(`/ajax/locations/${locationId}`, payload);
    },

    createLocation: async(customerId, payload) => {
        return client.post(`/ajax/customers/${customerId}/locations`, payload);
    },

    getCustomerRefunds: async (customerId, page = 1) => {
        return client.get(`/ajax/customers/${customerId}/refunds?page=${page}`);
    },

    getAllRefunds: async (page = 1) => {
        return client.get(`/ajax/refunds?page=${page}`);
    },

    getRefundDetails: async (refundId) => {
        return client.get(`/ajax/refunds/${refundId}`);
    },

    getShippingMethods: async () => {
        return client.get(`/ajax/customers/shipping_methods`);
    },

    getProducts: async (query, locationId, products_only = 0) => {
        return client.get('/ajax/products', {
            params: {
                q: query,
                per_page: 100,
                location_id: locationId,
                products_only: products_only
            },
        });
    },

    getThresholdAndGift: async () => {
        return client.get(`/ajax/threshold/show`);
    },

    updateThresholdAndGift: async (data) => {
        return client.put('/ajax/threshold/update', data);
    },

    getDraftOrder: async (id) => {
        return client.get(`/ajax/orders/draft/${id}`);
    },

    getOrder: async (id) => {
        return client.get(`/ajax/orders/${id}`);
    },

    placeDraftOrder: async (params) => {
        return client.post('/ajax/orders/draft', params);
    },

    placeRefund: async (params) => {
        return client.post('/ajax/orders/refund', params);
    },

    updateLocationAfterOrder: async (locationId, data) => {
        return client.put(`/ajax/locations/${locationId}/after-order`, data);
    },

    toggleCustomerOnHold: async (customerId) => {
        return client.put('/ajax/customers/' + customerId + '/toggle_on_hold', {});
    },

    createLocationCustomer: async (locationId, email) => {
        return client.post(`/ajax/locations/${locationId}/customer`, { email });
    },

    getInvoices: (customerId, page = 1) => {
        return client.get(`/ajax/customers/${customerId}/invoices?page=${page}`);
    },

    downloadInvoice: (customerId, invoiceId) => {
        return client.post('/ajax/customers/' + customerId + '/download_invoice/' + invoiceId, {}, {
            responseType: 'blob'
        });
    },

    hasCustomerOrders: (customerId) => client.get('/ajax/customers/' + customerId + '/has_orders'),

    deleteCustomer: async (customerId) => {
        return client.delete(`/ajax/customers/${customerId}`);
    },

    sendQuote: (data) => client.post('/ajax/orders/send-quote', data),

    deleteDiscountCode: (id) => client.delete(`/ajax/discount-codes/${id}`),

    getDiscountedLineItems: (id, page) => client.get(`/ajax/discount-codes/${id}/line-items?page=${page}`),

    findUsers: (params) => client.get('/ajax/users', {
        params: params,
    }),

    getUser: (id) => client.get(`/ajax/users/${id}`),

    getMe: () => client.get(`/ajax/users/me`),

    toggleAdminPrivileges: (userId) => client.put(`/ajax/users/${userId}/toggle-admin`),

    toggleOnHoldPrivileges: (userId) => client.put(`/ajax/users/${userId}/toggle-on-hold`),
}

export default Api;
